module.exports = {
  presets: [require('../ui-kit/tailwind.config.cjs')],
  content: ['./src/**/*.{vue,js,ts,jsx,tsx}', '../ui-kit/**/*.{vue,js,ts,jsx,tsx}', '!../ui-kit/node_modules/**/*'],
}
